/**
 *  @class
 *  @function ShopTheLook
 */
if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
    }
  }
  customElements.define('shop-the-look', ShopTheLook);
}

/**
 * Compact variant selector used only by the mobile Shop-the-look drawer.
 */
if (!customElements.get('hotspot-product-card')) {
  class HotspotProductCard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.variantSelect = this.querySelector('[data-hotspot-variant]');
      this.variantInput = this.querySelector('input[name="id"]');
      this.price = this.querySelector('[data-hotspot-price]');
      this.comparePrice = this.querySelector('[data-hotspot-compare-price]');
      this.image = this.querySelector('[data-hotspot-product-image] img');
      this.submitButton = this.querySelector('.single-add-to-cart-button');
      this.submitText = this.submitButton?.querySelector('.single-add-to-cart-button--text');

      if (this.variantSelect) {
        this.variantSelect.addEventListener('change', () => this.updateVariant());
        this.updateVariant();
      }
    }

    updateVariant() {
      const option = this.variantSelect?.selectedOptions?.[0];
      if (!option) return;

      if (this.variantInput) {
        this.variantInput.value = option.value;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (this.price) this.price.textContent = option.dataset.price || '';

      if (this.comparePrice) {
        const comparePrice = option.dataset.comparePrice || '';
        this.comparePrice.textContent = comparePrice;
        this.comparePrice.hidden = !comparePrice;
      }

      const available = option.dataset.available === 'true';
      if (this.submitButton) {
        this.submitButton.disabled = !available;
        this.submitButton.classList.toggle('sold-out', !available);
      }
      if (this.submitText) {
        this.submitText.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
      }

      const imageUrl = option.dataset.image;
      if (imageUrl && this.image) {
        this.image.src = imageUrl;
        this.image.removeAttribute('srcset');
      }
    }
  }

  customElements.define('hotspot-product-card', HotspotProductCard);
}
